// frontend/src/components/layouts/DefaultLayout.tsx
import { Container } from '@chakra-ui/react'
import Wave from 'react-wavify'
import { useEffect } from 'react'
import Web3 from 'web3'
import { useRecoilState } from 'recoil'
import { useNavigate, useLocation } from 'react-router-dom' // ✅ 추가
import { authState } from '../../atoms/auth'
import Header from './Header'
import Footer from './Footer'
import { useAuthState } from '../../utils/authUtils'

interface DefaultLayoutProps {
  children: React.ReactNode
  showHamburgerMenu?: boolean
}

const DefaultLayout = ({
  children,
  showHamburgerMenu = true
}: DefaultLayoutProps) => {
  const navigate = useNavigate()
  const location = useLocation() // ✅ 추가
  const [auth, setAuth] = useRecoilState(authState)
  const { reloadUser } = useAuthState()

  // 로그인 정보 리로드
  useEffect(() => {
    try {
      reloadUser()
    } catch (err) {
      //
    }
  }, [])

  // 페이지 전환 시 스크롤을 맨 위로 이동
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname])


  return (
    <>
      <Header />
      {children}
      <Footer />
    </>
  )
}

export default DefaultLayout
